import { trackEvent } from "core-lib/utils/events";
import { isParkPlusWebView } from "core-lib/utils/source";
import dayjs from "dayjs";
import ip from "icepick";
import { ColorsPallete } from "ui/primitives";
import { routes, ShortsSources } from "../constants";
import { disCardViewed } from "../constants/events";
import {
  DiscoverContentType,
  OffenceType,
  PostType,
  quizType,
  Short,
  View,
} from "../types";
import { isStringValid } from "core-lib/utils/utils";
import { getOrigin } from "core-lib/config/config";

export const formatVideoTime = (duration) => {
  if (!duration || Number.isNaN(duration)) return "00:00";
  const time = new Date(duration * 1000);
  const hh = time.getUTCHours();
  const mm = time.getUTCMinutes();
  const ss = time.getUTCSeconds().toString().padStart(2, "0");

  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};

export const cardLabel = (post: PostType) => {
  if (
    dayjs(post?.visibilityDate).format("YYYY-MM-DD") ===
    dayjs().format("YYYY-MM-DD")
  ) {
    return "POLL OF THE DAY";
  } else if (
    dayjs(dayjs().format("YYYY-MM-DD")).diff(
      dayjs(dayjs(post?.visibilityDate).format("YYYY-MM-DD")),
      "day"
    ) === 1
  ) {
    return "YESTERDAY'S POLL";
  } else {
    return dayjs(post?.visibilityDate).format("Do MMM, YYYY");
  }
};

export const getNativeDataForVideos = ({
  index,
  list,
  discoverVideoUrl = "",
  section = "",
}: {
  index: string | number;
  list: PostType;
  discoverVideoUrl?: string;
  section?: string;
}) => {
  const listNew: any[] = [];

  listNew.push({
    id: list?.uuid,
    title: list?.heading ?? list?.body,
    thumbnail_url: list?.media?.[0]?.thumbnailUrl,
    video_url: isStringValid(discoverVideoUrl)
      ? discoverVideoUrl
      : list?.media?.[0]?.url,
    video_id: null,
    like_count: list?.likeCount ?? 0,
    view_count: 0,
    channel_icon: list?.author?.profileImg,
    channel_name: list?.author?.displayName,
    channel_id: list?.author?.userId,
    share_text: list?.shareText,
    is_channel_followed: list?.author?.isFollowed ? 1 : 0,
    is_like: list?.isLiked ? 1 : 0,
    is_bookmark: list?.isBookmarked ? 1 : 0,
    body: list?.body,
    tags: list?.userSelectedTags,
    user_tagging_meta_data: list?.userTaggingData,
    content_type: list?.contentType,
    base_url: getOrigin() + routes.commentListForNative,
    comment_count: list?.commentCount,
  });

  // @ts-ignore
  window.redirection_script = null;
  // @ts-ignore
  window.like_count_sync = null;
  // @ts-ignore
  window.like_sync_data = null;
  console.log(window);

  return {
    source: ShortsSources.Community,
    activeIndex: index,
    list: listNew,
    section,
    bgColor: global?.window?.localStorage
      ? global.window.localStorage.getItem("theme") === "dark"
        ? ColorsPallete.black
        : ColorsPallete.white
      : ColorsPallete.white,
    on_close_script: `
    (function(){
     window.shortsRedirectionData = redirection_script;
     window.likeSyncData = like_count_sync;
     console.log(window.likeSyncData);
     const likeSyncBtn = document.getElementById('scLikeSyncBtn');
     console.log(likeSyncBtn);
     const shortsRedirectionBtn = document.getElementById('shortsRedirectionButton');
     
     if (likeSyncBtn) likeSyncBtn.click();
     if (window.shortsRedirectionData && shortsRedirectionBtn) shortsRedirectionBtn.click();           
    })()
  `,
  };
};

export const COMPONENT_TYPE = {
  insights: "insights",
  video: "playlist",
  reviews: "user_review",
  userReviews: "user_review",
  knowledgeCenter: "knowledge_center",
  aboutComponents: "about_components",
  addOns: "add_ons",
  carComparison: "vehicle_comparisons",
  shorts: "shorts",
  news: "news_feed",
};

export const getNativeJSONForDiscover = (index: number, list: Short[]) => {
  const listNew: any[] = [];
  let iter = 0;
  const len = list.length;
  for (iter; iter < len; iter += 1) {
    const item = list[iter];
    listNew.push({
      id: item.id,
      title: item.title,
      thumbnail_url: item.videoThumbnail,
      video_url: item.isYoutube ? null : item.videoId,
      video_id: encodeURIComponent(item.videoId),
      like_count: item.likeCount ?? 0,
      view_count: item.viewCount ?? 0,
      channel_icon: item.channelLogo,
      channel_name: item.channelName,
      channel_id: item.channelName,
      share_text: item.shareMsg,
      is_channel_followed: item.isChannelFollowed ? 1 : 0,
      is_like: item.isLiked ? 1 : 0,
      is_bookmark: item?.isBookmark ? 1 : 0,
    });
  }
  return {
    source: ShortsSources.Discover,
    activeIndex: index,
    list: listNew,
    bgColor: global?.window?.localStorage
      ? global.window.localStorage.getItem("theme") === "dark"
        ? ColorsPallete.black
        : ColorsPallete.white
      : ColorsPallete.white,
    on_close_script: "",
  };
};

export const getNativeDataForOffence = (
  offence: OffenceType[],
  idx: number,
  section: string = ""
) => ({
  source: ShortsSources.Offence,
  activeIndex: idx,
  list: offence?.map((e) => ({
    id: e?.uid,
    title: e?.userSelectedCategories?.reduce(
      (acc, e, idx) => `${acc}${idx > 0 ? "," : ""} ${e}`,
      ""
    ),
    thumbnail_url: e?.media?.[0]?.thumbnail,
    video_url: e?.media?.[0]?.url,
    video_id: null,
    like_count: null,
    view_count: e?.viewCount,
    channel_icon: null,
    channel_name: e?.city,
    channel_id: e?.userId,
    share_text: e?.shareUrl,
    userReactionType: e?.userReactionType,
    status: e?.status,
    reaction_count: e?.reactionCount,
    is_channel_followed: null,
    is_like: null,
    is_bookmark: null,
  })),
  section,
  bgColor: global?.window?.localStorage
    ? global.window.localStorage.getItem("theme") === "dark"
      ? ColorsPallete.black
      : ColorsPallete.white
    : ColorsPallete.white,
  on_close_script: `
    (function(){
      window.shortsRedirectionData = redirection_script;
      const elem = document.getElementById('content_shorts_btn');
      if (elem) elem.click();  
    })()
  `,
});

export function formatVideoViewCount(num: number): string {
  if (Number.isNaN(num)) return String(num);

  if (num < 9999) {
    return String(num);
  }

  if (num < 1000000) {
    return `${Math.round(num / 1000)}K`;
  }
  if (num < 10000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  }

  if (num < 1000000000) {
    return `${Math.round(num / 1000000)}M`;
  }

  if (num < 1000000000000) {
    return `${Math.round(num / 1000000000)}B`;
  }

  return "1T+";
}

export const updateSectionItems = (
  views: View[],
  itemId,
  propertyKey,
  propertyVal
) => {
  for (let viewIdx = 0; viewIdx < views.length; viewIdx++) {
    const { sections } = views[viewIdx];
    for (let sectionIdx = 0; sectionIdx < sections.length; sectionIdx++) {
      sections[sectionIdx].items.forEach((ele, idx: number) => {
        if (ele.id === itemId) {
          views = ip.updateIn(
            views,
            [viewIdx, "sections", sectionIdx, "items", idx, propertyKey],
            () => propertyVal
          );
        }
      });
    }
  }
  return views;
};

export function getCommonEventAttr() {
  const obj: any = {};
  obj.category = "Discover";
  obj.subcategory = "";
  return obj;
}

export const getLinkForViewAll = (contentType, id, seed) => {
  switch (contentType) {
    case DiscoverContentType.BLOG:
      return `/discover/blogs?id=${id}&seed=${seed}`;
    case DiscoverContentType.IMAGE:
      return `/discover/images?id=${id}&seed=${seed}`;
    case DiscoverContentType.NEWS:
      return `/discover/news?id=${id}&seed=${seed}`;
    case DiscoverContentType.PLAYLIST:
      return `/discover/videos?id=${id}&seed=${seed}`;
    case DiscoverContentType.SHORT:
      return `/discover/shorts?id=${id}&seed=${seed}`;
    case DiscoverContentType.STORY:
      return `/discover/insights?id=${id}&seed=${seed}`;
    case DiscoverContentType.VIDEO:
      return `/discover/videos?id=${id}&seed=${seed}`;
    default:
      return "discover";
  }
};

export const cardViewedEvent = ({ card, page, section, source }) => {
  trackEvent({
    name: disCardViewed.name,
    defaultAttr: getCommonEventAttr(),
    attributes: {
      [disCardViewed.attributes.cardId]: card?.id,
      [disCardViewed.attributes.page]: page,
      [disCardViewed.attributes.scrollDepth]: global?.window?.scrollY,
      [disCardViewed.attributes.section]: section,
      [disCardViewed.attributes.source]: source,
      [disCardViewed.attributes.title]: card?.title,
      [disCardViewed.attributes.uiType]: card?.uiType,
    },
  });
};

export const getPercentage = (quiz: quizType) => {
  let totalVotes = 0;
  let correctVotes = 0;
  quiz?.options?.forEach((item) => {
    totalVotes += item?.optionVotes ?? 0;
    if (quiz?.correctOptionId === item?.optionId) {
      correctVotes = item?.optionVotes ?? 0;
    }
  });
  return totalVotes > 0 ? (correctVotes / totalVotes) * 100 : 0;
};

export const checkVersion = () => {
  return isParkPlusWebView();
};
